<template>
  <div class="lookSnapshootBox" v-loading="loading">
    <div class="lookSnapshootBoxIn">
      <!-- 头部 -->
      <div class="returnButton" @click="returnButton">
        <i class="iconfont left icon-zuojiantou" />
        返回
        <i class="iconfont icon-guanbi closeIcon" @click="closePop" />
      </div>
      <div class="contentIn custom_scroll">
        <h3 class="title">
          {{ detailsData.article_title ? detailsData.article_title : '--' }}
        </h3>
        <p class="author">
          作者
          <span class="name">
            {{ detailsData.author ? detailsData.author : '--' }}
          </span>
          <i class="time">
            {{ detailsData.publish_time | parseTime }}
          </i>
        </p>
        <div v-if="detailsData.article_content">
          <template v-for="(item, index) in contentArr">
            <template v-if="item.isVote">
              <vote-list :key="index" :vote-id="item.voteId" />
            </template>
            <template v-else>
              <div :key="index" class="content" v-html="item.text" />
            </template>
          </template>
        </div>
        <div v-else class="noData">
          <img
            class="release-list-noData-img"
            src="https://vfiles.gtimg.cn/vupload/20200731/2e4c871596188639161.png"
          />
          <div class="release-list-noData-word">没有找到相关数据</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPublishArticleWechatDetailApi } from '@/api/releaseManagement';
import voteList from '../voteList';
import { getArticlePublishLogDetail } from '@/api/dataCenter';
export default {
  name: 'LookSnapshoot',
  components: {
    voteList,
  },
  props: {
    publishRecordId: {
      type: [String, Number],
      default: '',
    },
    // 文章类型，0为公众号，1为小程序，2为企业微信
    publishType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detailsData: {
        article_title: '',
        author: '',
        publish_time: 0,
      },
      articleText: {},
      contentArr: [],
      loading: true,
    };
  },
  mounted() {
    this.getArticleAlbum();
  },
  methods: {
    returnButton() {
      this.$emit('hideShow');
    },
    /* 获取文章快照 */
    getArticleAlbum() {
      this.loading = true;
      if (this.publishType === 0) {
        // 公众号文章查询接口使用老的
        getPublishArticleWechatDetailApi({
          id: this.publishRecordId,
          operation_type: '1',
        })
          .then((res) => {
            this.loading = false;
            if (res) {
              this.detailsData = res;
              this.genHandleText(res.article_content);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      } else {
        // 小程序和企业微信使用新的接口（1为小程序，2为企业微信）
        getArticlePublishLogDetail({
          pushId: String(this.publishRecordId),
          pushType: this.publishType,
        })
          .then((res) => {
            // console.log(res);
            this.loading = false;
            if (res) {
              this.detailsData = {
                article_title: res.articleTitle,
                article_content: res.articleContent,
                publish_time: res.publishTime,
                author: res.author,
              };
              this.genHandleText(res.articleContent);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      }
    },
    genHandleText(str) {
      const TAG_RE = /<p><i voteId="(\S*)"><\/i><\/p>/gi;
      // let spaceRex1 = /(\s*<[^>]+>)([^<>]*)(<\/[^>]+>\s*)/g
      const spaceRex1 = /(<.*?>)([^<>]*)(<\/.*?>)/g;
      const spaceRex2 = /\s/g;
      str = str.replace(spaceRex1, (str, $1, $2, $3) =>
        [$1, $2.replace(spaceRex2, '&nbsp;'), $3].join(''),
      );
      const arr = str.replace(TAG_RE, `[vote]$1[voteId][vote]`).split('[vote]');
      this.contentArr = arr.map((item) => ({
        text: item,
        isVote: this.isVoteMe(item),
        voteId: this.isVoteMe(item) ? item.replace(/\[voteId\]/, '') : null,
      }));
    },
    /* 判断是否全是数字*/
    isVoteMe(item) {
      if (item.indexOf('[voteId]') > -1) {
        return true;
      }
      return false;
    },
    /* 关闭弹窗 */
    closePop() {
      this.$emit('closePop');
    },
  },
};
</script>
<style lang="scss" scoped>
// @import './quill.scss';
/* 关闭查看快照 */
.lookSnapshootBox {
  width: 100%;
  .lookSnapshootBoxIn {
    width: 100%;
    height: 100%;
    padding-bottom: 40px;
    box-sizing: border-box;
    .returnButton {
      padding: 0 20px;
      height: 48px;
      line-height: 48px;
      color: #909399;
      font-size: 16px;
      display: inline-block;
      cursor: pointer;
      width: 100%;
      border-bottom: 1px solid #eee;
      .iconfont.left {
        font-size: 14px;
        color: #666;
        position: relative;
        top: 1px;
        margin-right: 5px;
        font-weight: 800;
      }
      .closeIcon {
        font-size: 24px;
        color: #666;
        float: right;
      }
    }
    .contentIn {
      height: calc(100% - 48px);
      overflow-y: auto;
      padding: 0 20px;
      // 滚动条样式
    }
    .title {
      font-size: 24px;
      color: #606266;
      line-height: 28px;
      margin: 30px auto 20px;
      word-break: break-all;
    }
    .author {
      font-size: 16px;
      color: #606266;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      padding-bottom: 19px;
      .name {
        font-size: 16px;
        color: #2f96ff;
        margin: 0 8px 0 4px;
      }
    }
    .content {
      margin-top: 13px;
      color: #606266;
      word-break: break-all;
      ::v-deep p {
        line-height: 18px;
      }
      ::v-deep img {
        max-width: 100%;
        margin: 10px auto;
      }
    }
    .noData {
      width: 100%;
      padding: 20px 0;
      text-align: center;
      .release-list-noData-img {
        width: 240px;
        height: 192px;
        margin-top: 10vh;
      }
      .release-list-noData-word {
        font-size: 14px;
        color: #606266;
        text-align: center;
        margin-top: 4px;
      }
    }
  }
}
</style>
